import React from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import { useDispatch } from "react-redux";
import { contact } from "../../actions/contactAction";
const VerificationFailed = () => {
  const dispatch = useDispatch();
  const initialValues = {
    name: "",
    email: "",
    message: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("This field is required"),
    email: Yup.string().email().required("This field is required"),
    message: Yup.string().required("This field is required"),
  });

  const onSubmit = (values) => {
    const params = {
      name: values.name,
      email: values.email,
      reason: "Verification Failed",
      action: "contact",
      message: values.message,
      new_user: "true",
    };
    dispatch(contact({ params }));
  };

  return (
    <div className="template-wrapper">
      <h2 className="template-heading">Verification Failed</h2>

      <p className="template-description">
        We apologize, but your verification failed. Please try clicking on
        “ACTIVATE” from your email again or email our team at{" "}
        <a href="mailto:info@myherbpharm.com"> info@myherbpharm.com.</a>
      </p>

      <h2>Leave a Reply</h2>
      <p className="template-description">
        Your email address will not be published. Required fields are marked *
      </p>

      <div className="contact-form">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {(formik) => {
            return (
              <Form>
                <FormikControl
                  control="textarea"
                  label="* comment"
                  name="message"
                  rows="6"
                  handleBlur={formik.handleBlur}
                  hasError={formik.errors.message && formik.touched.message}
                />
                <FormikControl
                  control="forminput"
                  type="text"
                  label="* Name"
                  name="name"
                  handleBlur={formik.handleBlur}
                  hasError={formik.errors.name && formik.touched.name}
                />
                <FormikControl
                  control="forminput"
                  type="text"
                  label="* email"
                  name="email"
                  handleBlur={formik.handleBlur}
                  hasError={formik.errors.email && formik.touched.email}
                />

                <div className="submit-section">
                  <button className="btn-orange" type="submit">
                    Post Comment
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default VerificationFailed;
